import React, { useState } from 'react'
import parse, { HTMLReactParserOptions, domToReact } from 'html-react-parser'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Container } from './styled'
import { ContactForm } from 'app/livbrite/components/ContactForm'

export const Inspiration = () => {
  const [openModal, setOpenModal] = useState(false)
  const staticBlockID = CMS_BLOCK.HOME_INSPIRATION
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false
  })

  if (!staticBlock.content) return null

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      const { attribs, children } = domNode

      if (!attribs) {
        return
      }

      if (attribs.class === 'contact-trigger') {
        return <span onClick={() => setOpenModal(true)} className='contact-trigger'>{domToReact(children, options)}</span>
      }
    }
  }

  return (
    <>
      <Container>
        {parse(staticBlock.content, options)}
      </Container>
      <ContactForm showForm={openModal} type='community_contact' setShowForm={setOpenModal} />
    </>
  )
}
